import ecartimg from '../ecartimg.jpg';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ShoppingBag, CreditCard, Trash2, ArrowLeft, Copy, CheckCircle, ChevronDown, Tag } from 'react-feather';
import React,{ useContext, useState, useEffect, useRef } from 'react';
import { CartContext } from '../context';
import api5 from './api5';
import { ExchangeRateContext } from '../ExchangeRateContext';
import { PaystackButton } from 'react-paystack';
import { v4 as uuidv4 } from 'uuid';
import { FaCashRegister, FaTags, FaTicketAlt } from 'react-icons/fa';
import 'intasend-inlinejs-sdk'
import CheckoutProgressModal from './CheckoutProgressPopup';
import GooglePlacesInput from './GooglePlacesInput';

const googleLibraries = ["places"];
function Checkout() {
    const orderId = uuidv4();
    const { cartData, setCartData } = useContext(CartContext);
    const [cartButtonClickStatus, setCartButtonClickStatus] = useState(true);
    const [sizeQtyData, setSizeQtyData] = useState({});
    const [quantities, setQuantities] = useState({}); 
    const [confirmOrder, setConfirmOrder] = useState(false);
    const [PayMethod, SetPayMethod]=useState('');
    const [PayError, SetPayError]=useState('');
    const [deliveryFee, SetdeliveryFee]=useState(0);
    const [MobileNoError,setMobileNoError]=useState(false);
    const [status] = useState('Pending');
    const [loadingPay,setloadingPay]=useState(false);
    const [UsernameError,setUsernameError]=useState(false);
    const [EmailError,setEmailError]=useState(false);
    const [UsernameError0,setUsernameError0]=useState('0');
    const [EmailError0,setEmailError0]=useState('');
    const [ProfileData,setProfileData]=useState({  
        "user_id":'', 
        "first_name":'',
        "last_name":'',
        "username":'',
        "customer_email":'',
        "mobile":'',
        "address":'',
        "p_image":'',
    });
      
    const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;
    const publicKey_intasend = process.env.REACT_APP_INTASEND_PUBLIC_KEY;
    const paymentMode = "paystack";

    const { exchangeRates, baseCurrency } = useContext(ExchangeRateContext);
    if(exchangeRates==null){window.location.reload();}    
    const [location, setLocation] = useState('');
    const [voucher, setVoucher] = useState('');
    const [voucherValue, setVoucherValue] = useState(0);
    const [whatsappno, setWhatsappno] = useState(0);
    const [delivery, setDelivery] = useState('');
    const [error, setError] = useState('');
    const [VoucherError,setVoucherError]=useState(false);
    const [uploading, setUploading] = useState(false);
    const [clicked, setClicked] = useState(null);

    const [pymtFormData0, setPymtFormData0]=useState();  
    const [DeliveryInfo, setDeliveryInfo]=useState();
    
    const [custName, setCustName] = useState('');

    const [waLink, setWaLink] = useState('');
    const waAnchorRef = useRef(null);
    
    const cartItems = cartData?.length || 0;
    let sum = 0;

    const banksIntasend = [
        { "bank_name": "KCB", "bank_code": "1", "bank_paybill": "522522" },
        { "bank_name": "Standard Chartered Bank KE", "bank_code": "2", "bank_paybill": "329329" },
        { "bank_name": "Barclays Bank", "bank_code": "3", "bank_paybill": "303030" },
        { "bank_name": "NCBA", "bank_code": "7", "bank_paybill": "880100" },
        { "bank_name": "Prime Bank", "bank_code": "10", "bank_paybill": "982800" },
        { "bank_name": "Cooperative Bank", "bank_code": "11", "bank_paybill": "400200" },
        { "bank_name": "National Bank", "bank_code": "12", "bank_paybill": "547700" },
        { "bank_name": "Citibank", "bank_code": "16", "bank_paybill": "" },
        { "bank_name": "Habib Bank AG Zurich", "bank_code": "17", "bank_paybill": "" },
        { "bank_name": "Middle East Bank", "bank_code": "18", "bank_paybill": "" },
        { "bank_name": "Bank of Africa", "bank_code": "19", "bank_paybill": "972900" },
        { "bank_name": "Consolidated Bank", "bank_code": "23", "bank_paybill": "508400" },
        { "bank_name": "Credit Bank Ltd", "bank_code": "25", "bank_paybill": "972700" },
        { "bank_name": "Stanbic Bank", "bank_code": "31", "bank_paybill": "600100" },
        { "bank_name": "ABC Bank", "bank_code": "35", "bank_paybill": "111777" },
        { "bank_name": "Spire Bank", "bank_code": "49", "bank_paybill": "498100" },
        { "bank_name": "Paramount Universal Bank", "bank_code": "50", "bank_paybill": "" },
        { "bank_name": "Jamii Bora Bank", "bank_code": "51", "bank_paybill": "529901" },
        { "bank_name": "Guaranty Bank", "bank_code": "53", "bank_paybill": "910200" },
        { "bank_name": "Victoria Commercial Bank", "bank_code": "54", "bank_paybill": "" },
        { "bank_name": "Guardian Bank", "bank_code": "55", "bank_paybill": "344501" },
        { "bank_name": "I&M Bank", "bank_code": "57", "bank_paybill": "542542" },
        { "bank_name": "DTB", "bank_code": "63", "bank_paybill": "516600" },
        { "bank_name": "Sidian Bank", "bank_code": "66", "bank_paybill": "111999" },
        { "bank_name": "Equity Bank", "bank_code": "68", "bank_paybill": "247247" },
        { "bank_name": "Family Bank", "bank_code": "70", "bank_paybill": "222111" },
        { "bank_name": "Gulf African Bank", "bank_code": "72", "bank_paybill": "985050" },
        { "bank_name": "First Community Bank", "bank_code": "74", "bank_paybill": "" },
        { "bank_name": "KWFT Bank", "bank_code": "78", "bank_paybill": "101200" },
        { "bank_name": "Housing Finance Company Limited (HFCK)", "bank_code": "61", "bank_paybill": "100400" },
        { "bank_name": "Mayfair Bank Limited", "bank_code": "65", "bank_paybill": "" }
    ];
  
    const inputHandler =(event) => {
        setProfileData({
            ...ProfileData,
            [event.target.name]:event.target.value
        });
    };

    const handleClick = (type) => {
        setClicked(type);           // Hide the other button
        setloadingPay(true);        // Optional: Set loading if needed
        startUpload(type);
    };

    function currencyChange(price,currency){
        // Convert price from the product's original currency to the selected base currency
        const productExchangeRate = exchangeRates[currency] || 1;
        const baseExchangeRate = exchangeRates[baseCurrency] || 1;

        // Calculate the converted price
        const convertedPrice = ((price / productExchangeRate) * baseExchangeRate).toFixed(2);
        
        return convertedPrice;
    }

    if (cartData) {
        cartData.forEach(item => {
            var itemQty =
            quantities[item.product.id] ||
            item.product.quantity ||
            1;
            sum += (((parseFloat(currencyChange(Math.round(item.product.price),item.product.currency))) * itemQty + deliveryFee) - voucherValue);
        });
    }
    const baseUrl = process.env.REACT_APP_BASE_URL;
    
    const vendor_login= localStorage.getItem("vendor_login");
    const vendor_currency = localStorage.getItem("VendorCurrency");
    const previousCart0 = localStorage.getItem('cartData');
    const cartJson = JSON.parse(previousCart0);
    var firstProductId="";
    if (cartJson && cartJson.length > 0) {
        firstProductId = cartJson[0].product.id;    
    }else{firstProductId = "null";}

    // Fetch size quantities for each product in the cart
    useEffect(()=>{
        if(firstProductId !== "null"){
            fetchData(baseUrl+'/pymt/'+firstProductId+'/');
        }        
    },[]);

    useEffect(() => {
        if (waLink && waAnchorRef.current) {
            waAnchorRef.current.click();
        }
    }, [waLink]);

    useEffect(() => {
        const storedLocation = localStorage.getItem('location');
    
        if (storedLocation) setLocation(storedLocation);
    
        if (cartItems > 0) {
            const initialQuantities = {};

            cartData.forEach(item => {
                const prd = item.product.id;
                const sz = item.product.size;

                fetchSizeQty(prd, sz);

                initialQuantities[prd] =
                    item.product.quantity || 1;
            });

            setQuantities(initialQuantities);
        }
    }, [cartData, cartItems]);

    // ✅ Detect shop name from localStorage first
    useEffect(() => {
        const storedCustName = localStorage.getItem('customer_username');
        if (storedCustName && storedCustName.trim() !== '') {
            setCustName(storedCustName);
            
            setProfileData({
                "username":storedCustName,
                "email":storedCustName+"@gmail.com",
            });
        } else {
            setCustName('');
        }
    }, []);


    function fetchSizeQty(prd, sz) {
        fetch(`${baseUrl}/sizeqty/${sz}/${prd}/`)
            .then(response => response.json())
            .then(data => {
                // Update size quantities for the specific product
                setSizeQtyData(prevData => ({
                    ...prevData,
                    [prd]: data.results // Store the results under the product ID
                }));
            });
    }
    
    const handleQtyChange = (
        productId,
        newQty
    ) => {

        setQuantities(prev => ({
            ...prev,
            [productId]: newQty
        }));

        const cart =
            JSON.parse(
                localStorage.getItem("cartData")
            ) || [];

        const updatedCart = cart.map(item => {

            if (
                item.product.id === productId
            ) {

                item.product.quantity =
                    newQty;

                item.total_amount =
                    parseFloat(
                        item.product.price
                    ) * newQty;
            }

            return item;
        });

        localStorage.setItem(
            "cartData",
            JSON.stringify(updatedCart)
        );

        setCartData(updatedCart);
    };

    const cartRemoveButtonHandler = (product_id) => {
        const previousCart = JSON.parse(localStorage.getItem('cartData')) || [];
        const updatedCart = previousCart.filter(cart => cart.product.id !== product_id);
        localStorage.setItem('cartData', JSON.stringify(updatedCart));
        setCartData(updatedCart);
    };

    const getQty = (productId) => {
        return quantities[productId] || 1; // Default to 1 if quantity is not set
    };
    

    const handleVoucherSuccess = async () => {        
        try {
            const response = await fetch(baseUrl+'/apply-voucher-update/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    voucher_code: voucher,
                    order_id: orderId, 
                }),
            });
        } catch (err) {
            setVoucherError('');return;
        }
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleDateString('en-US', { month: 'short' }); // "Nov"
        const day = date.getDate(); // 1
        const time = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase(); // "11:01 pm"
    
        return `${month} ${day}, ${time.replace(':', '.')}`; // "Nov 01 11.01pm"
    }
    
    async function handleSubmit(selectedMethod){
        setConfirmOrder(true);
        const currentDate = new Date();
        const tarehe = formatDate(currentDate);
    
        const storedcartData = localStorage.getItem('cartData');
        if (storedcartData == "") {return;}  
        const parsedcartData = JSON.parse(storedcartData);
        const orderItems = parsedcartData.map((item) => ({
            product_id: item.product.id,
            size: item.product.size,
            qty: quantities[item.product.id] || 1,
            price: parseFloat(Math.round(item.product.price)),
            usd_price: parseFloat(Math.round(item.product.price)) / 133.33, // Example conversion rate
        })); 

        const formData0 = {
            order_id: orderId,
            order_items: orderItems,
            customer_name: ProfileData.username,
            customer_phone: ProfileData.mobile || 0,
            customer_email: ProfileData.email || 0,
            delivery_loc: location,
            delivery_fee: deliveryFee,
            payment_method: selectedMethod || PayMethod,
            paymentMethod: selectedMethod || PayMethod,
            total_amount: sum,
            customer_email: ProfileData.email, // Ensure email is populated
        }; 

        try {
            const response = await api5.post(baseUrl+'/checkout/', formData0);
            if (response.data.success) {
                if (PayMethod !== 'AUTO') {
                    localStorage.removeItem('cartData');
                    handleVoucherSuccess();

                    if (whatsappno) {
                        let message = `Wassgud, ${ProfileData.username} here 👋\nI just picked up some cool stuff from your store!\n\n🛒 *Cart Items:*`;

                        for (let item of cartJson) {
                            const p = item.product;
                            message += `\n- ${p.title} (Size: ${p.size}) — ${p.quantity} pc @ ${p.currency} ${p.price}`;
                        }

                        // 🏠 Add delivery info
                        message += `\n\n📍 *Delivery Location:* ${location || "Not specified"}`;
                        message += `\n🚚 *Delivery Fee:* KES ${deliveryFee.toFixed(2)}`;

                        // 🎁 Add voucher info if present
                        if (voucher && voucherValue > 0) {
                            message += `\n🎁 *Voucher Applied:* ${voucher.toUpperCase()} (-KES ${voucherValue.toFixed(2)})`;
                        }

                        // 💰 Add total
                        message += `\n\n💰 *Total (incl. delivery)*: KES ${sum.toFixed(2)}`;// 🙏 Thank-you footer
                        message += `\n\n🕒 ${tarehe}`;

                        const encodedMessage = encodeURIComponent(message);
                        const waUrl = `https://api.whatsapp.com/send?phone=${whatsappno}&text=${encodedMessage}`;

                        // ✅ Use a short delay to avoid blocking WhatsApp on mobile
                        setTimeout(() => {
                            window.location.href = `/order/success/${response.data.redirect_url}`;
                        }, 10000); // wait 3 seconds to allow user to switch to WhatsApp

                        setTimeout(() => {
                            window.location.replace(waUrl); // replaces current page instead of opening a new tab
                        }, 4000);

                        
                        return; // ✅ Exit here to avoid hitting the next redirect
                    } else {
                        // No WhatsApp? Redirect to success page immediately
                        window.location.href = `/order/success/${response.data.redirect_url}`;
                    }
                } else {
                    // AUTO logic
                    setloadingPay(true);  
                    SetPayError('');
                    setMobileNoError('');
                    setUsernameError(false);
                    setEmailError(false);
                }
            }else {                
                setloadingPay(false);  
                SetPayError('');
                setMobileNoError('');
                setUsernameError(false);
                setEmailError(false);
                setCartButtonClickStatus(true);  
                SetPayError(`Incomplete Payment, Kindly try again`);
            }            
        } catch (error) {
            //console.error('Error processing payment:', error);
            setloadingPay(false);
            SetPayError('Incomplete Payment, Kindly try again');
        }
    };

    const handlePaymentSuccess = async (response) => {
        localStorage.removeItem('cartData');    

        const payload = {
          trxref: response.trxref,
          trans: response.trans,
          order_id:orderId,
        };
    
        try {
          const res = await api5.post(baseUrl+`/payment/success/`, payload);      
          window.location.href = res.data.redirect_url;
        } catch (error) {
          //console.error('Failed to update order status:', error.response?.data || error.message);
          //alert('Failed to update order status.');
        }
    };

    const handlePaymentClose = async () => {        
        try {
            SetPayError('Transaction was not completed.');
        } catch (error) {
          //console.error('Failed to restore stock:', error.response?.data || error.message);
        }
    };
    
    const onSuccess = async (response) => {
        await startUpload("AUTO"); // Wait for DB write via handleSubmit
        handleVoucherSuccess();    // Safe to run now
        handlePaymentSuccess(response);
    };
    

    const onClose = () => {
        //alert('Transaction was not completed, window closed.');
        //console.error('Transaction was not completed, window closed.');
        handlePaymentClose();
    };

    const confirmOrderHandler = async () => {
        setVoucherError('');
        if (!location.trim() && delivery !== "Instore Pickup") {
            setError('*Delivery Address cannot be empty');
        } else if (delivery === "") {
            setError('*Delivery Category cannot be empty');
        } else {
            if (delivery === "Instore Pickup") {
                setLocation(delivery);
            }
            
            if (voucher.trim() !== "") {
                try {
                    const response = await fetch(baseUrl+'/apply-voucher/', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            voucher_code: voucher,
                        }),
                    });

                    const data = await response.json();

                    if (data.success) {
                        setVoucherValue(data.discount);
                        setVoucherError('');
                    } else {
                        setVoucherError('Invalid voucher code');return;
                    }
                } catch (err) {
                    setVoucherError('Failed to apply voucher. Try again.');return;
                }
            }
    
            setError('');
            localStorage.setItem('location', location);
            setCartButtonClickStatus(false);
        }
    };
    

    function fetchData(baseurl){
        fetch(baseurl)
        .then((response) => response.json())
        .then((data) => {
            setProfileData({
                "user_id":data.user.id,
                "first_name":data.user.first_name,
                "last_name":data.user.last_name,
                "username":custName,
                "email":data.user.email,
                "mobile":data.mobile,
                "address":data.address,
                "p_image":data.profile_img,
            });
        });
    }  
    
    const backHandler = () => {   
        setloadingPay(false);  
        SetPayError('');
        setMobileNoError('');
        setUsernameError(false);
        setEmailError(false);
        setCartButtonClickStatus(true);        
    }

    const [input1, setInput1] = useState();
    const [input2, setInput2] = useState();
    const [copySuccess, setCopySuccess] = useState(''); 
    const [paybill, setPaybill] = useState("");

    const copyToClipboard = async (text, inputNumber) => {
        try {
        await navigator.clipboard.writeText(text);
        setCopySuccess(`Copied input ${inputNumber} successfully!`);
        setTimeout(() => setCopySuccess(''), 2000); // Clear message after 2 seconds
        } catch (err) {
        setCopySuccess('Failed to copy!');
        }
    };
    
    function fetchData(baseurl){
        fetch(baseurl)
        .then((response) => response.json())
        .then((data) => {
           setPymtFormData0(data);
           setDeliveryInfo(data.delivery_locations);
           setInput1(data.pay_mode_desc_paybill);
           setInput2(data.acc_no);
           setWhatsappno(data.whatsapp);
        });
    }
    
    const handleDeliveryChange = (e) => {
        const value = e.target.value;
        setDelivery(value);
    
        // Extract fee from the selected value
        const parts = value.split('-');
        if (parts.length === 2) {                        
            SetdeliveryFee(parseInt(currencyChange(parts[1],vendor_currency), 10));
        } else {
            SetdeliveryFee(0); // Reset if the format is incorrect
        }
    };

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailPattern.test(email)) {
            setEmailError(true);setEmailError0('0');
        } else {
            setEmailError(false);setEmailError0('1');
        }
    };
    const validateUsername = (username) => {
        if(username.length<3){
            setUsernameError(true);setUsernameError0('0'); return;
        }else{
            setUsernameError(false);setUsernameError0('1');
        } 
    };

    var strnm = localStorage.getItem('active_vendor_name');
    var homeroute = `categories`;
    if(strnm !== ''){homeroute = `/${strnm}`;}

    
    async function startUpload(section) { 
        const previousCart = localStorage.getItem('cartData');
        const cartJson = JSON.parse(previousCart);
        let total_amount = 0;

        if(ProfileData.username.length < 3){
            setUsernameError(true); 
            setloadingPay(false); 
            return;
        } else {
            setUsernameError(false);
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (ProfileData.email !== '' && !emailPattern.test(ProfileData.email)) {
            setEmailError(true); 
            setloadingPay(false); 
            return;
        } else {
            setEmailError(false);
        }

        if(section !== "AUTO"){
            if(ProfileData.mobile.length < 12){
                setMobileNoError(true); 
                setloadingPay(false); 
                return;
            } else {
                setMobileNoError(false);
            }
        }
        
        setClicked(section);       // Hide unclicked button immediately
        setloadingPay(true);       // Show loading on clicked
        SetPayError('');           // Clear any previous errors
        SetPayMethod(section);     // Save selected payment method
        //console.log(section);

        try {
            const response = await api5.post(baseUrl + '/get-latest-prices/', {
                products: cartJson.map(cart => cart.product.id),
            });
            const latestPrices = response.data;

            for (let cart of cartJson) {
                const latestPrice = latestPrices[cart.product.id];
                if (!latestPrice || parseFloat(cart.product.price) !== parseFloat(latestPrice)) {
                    alert("Network Error, Kindly try again.");
                    localStorage.removeItem('cartData');
                    window.location.href = '/checkout';
                    return;
                }
                total_amount += parseFloat(cart.product.price);
            }

            if(section !== "AUTO"){
                handleSubmit(section); // Submit form or payment request
            }

        } catch (error) {
            window.location.href = '/order/failed';
        }
    }

    //console.log("IntaSend Public Key:", publicKey_intasend);


    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://unpkg.com/intasend-inlinejs-sdk@4.0.7/build/intasend-inline.js";
        script.async = true;

        script.onload = () => {
            //console.log("✅ IntaSend SDK loaded");
            const pubKey = process.env.REACT_APP_INTASEND_PUBLIC_KEY;

            if (window.IntaSend) {
            window.intasendInstance = new window.IntaSend({
                publicAPIKey: pubKey,
                live: true,
            });

            window.intasendReady = true;
            }
        };

        document.body.appendChild(script);
    }, []);

    useEffect(() => {
        if (!input1) return;

        // Try to match by partial name too for flexibility
        const matchedBank = banksIntasend.find((bank) =>
            input1.toLowerCase().includes(bank.bank_name.toLowerCase())
        );

        if (matchedBank && matchedBank.bank_paybill) {
            setPaybill(matchedBank.bank_paybill);
        } else {
            setPaybill("Not Found");
        }
    }, [input1]);

   const handlePayNowClick = async () => {
    const sum_intasend = sum;
        if (!window.intasendReady || !window.intasendInstance) {
            setloadingPay(true);
            //alert("Payment system is still loading. Please try again shortly.");
            return;
        }

        setloadingPay(true);

        try {
            await startUpload("AUTO"); // wait for upload to complete
        } catch (err) {
            //console.error("❌ Upload failed:", err);
            setloadingPay(false);
            return;
        }

        const intasend = window.intasendInstance;

        // Clear previous listeners (important if clicking button multiple times)
        //intasend.off("COMPLETE");
        //intasend.off("FAILED");
        //intasend.off("IN-PROGRESS");

        intasend
            .on("COMPLETE", async (results) => {
            handleSubmit("AUTO");
            handleVoucherSuccess();

            const {
                tracking_id,
                provider,
                value,
                net_amount,
                api_ref,
                account: phone_number,
                meta: {
                customer: { email, first_name }
                }
            } = results;

            const payload = {
                trxref: tracking_id,
                trans: {
                tracking_id,
                provider,
                value,
                net_amount,
                api_ref,
                phone_number,
                email,
                first_name,
                },
                order_id: orderId,
            };

            localStorage.removeItem('cartData');

            try {
                const res = await api5.post(baseUrl + `/payment/success/`, payload);
                window.location.href = res.data.redirect_url;
            } catch (error) {
                //console.error('❌ Order update failed:', error.response?.data || error.message);
            }
            })
            .on("FAILED", () => {
            handlePaymentClose();
            });

        // Trigger the payment UI
        intasend.run({
            amount: sum_intasend, // <- Replace with your dynamic amount
            email: ProfileData.email, // <- Replace with actual customer email
            currency: "KES",
            first_name:ProfileData.username,
            api_ref:orderId,
        });

        //setloadingPay(false);
    };

    return (        
        <>                                                                    
            <Helmet>
                <title>Checkout</title>
                <meta name="description" content={`Checkout`} />
            </Helmet>
            <section className="container mtopcon cartmaincon normal-mt-sctn">   
                {cartButtonClickStatus == true && <>
                    {cartItems > 0 && (
                        <div className="row">  
                            <h3 className="mb-2 fw800">Checkout ({cartItems})</h3>
                            <div className="col-12 col-md-6 col-lg-6 mb-3 p-3">
                                {cartData.map((item, index) => (
                                    <div className='cartordcon' key={item.product.id}>
                                        <div className="row ord-bg bg-white p-2 pointer hvr bx-shadow">
                                            <div className="col-auto me-2 p-0">
                                                <div className="ord-img br-10">
                                                    <Link>
                                                        <img src={item.product.image} alt={item.product.title}/>
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="col-8 pl-0 pr-0">
                                                <div className="row">
                                                    <div className="col-8 ord-sz">
                                                        <Link className='text-black'>
                                                            {item.product.title}
                                                        </Link>
                                                    </div>
                                                    <div className="col-4 ord-sz text-primary text-center">                                                    
                                                        <span className="badge rounded-pill text-bg-warning">Size: {item.product.size}</span>
                                                    </div>
                                                    <div className="col-7 ord-sz grey-text">
                                                        {baseCurrency} {Intl.NumberFormat().format(currencyChange(Math.round(item.product.price),item.product.currency))}
                                                    </div>
                                                    <div className="col-5 ord-sz grey-text">
                                                        <div className="row"> 
                                                            <div className='col-5 p-0'>Qty</div>
                                                            <div className='col-5 p-0 text-left'>
                                                                <select 
                                                                    className="w-100 h-80 border-2 rounded-2 bg-white" 
                                                                    name='quantity'
                                                                    value={quantities[item.product.id] || 1}
                                                                    onChange={(e) => handleQtyChange(item.product.id, parseInt(e.target.value))}
                                                                >
                                                                    {sizeQtyData[item.product.id]?.map((sizeItem, sizeIndex) => {
                                                                        const options = [];
                                                                        for (let i = 1; i <= sizeItem.qty; i++) {
                                                                            options.push(
                                                                                <option key={`${sizeIndex}-${i}`} value={i}>{i}</option>
                                                                            );
                                                                        }
                                                                        return options;
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-1 col-lg-2 ms-3 p-0 f8 text-right mt-1 lh34">
                                                <Trash2 onClick={() => cartRemoveButtonHandler(item.product.id)} />
                                            </div>
                                        </div>
                                    </div> 
                                ))}
                            </div>
                            <div className="col-12 col-md-6 col-lg-6">
                                <div
                                    style={{
                                    background: "#fff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "18px",
                                    padding: "1.25rem 1.25rem 0.4rem 1.25rem",
                                    boxShadow: "0 1px 3px rgba(0,0,0,.04)",
                                    }}
                                >

                                    {/* Header */}
                                    <div className="mb-4">

                                        <div
                                            style={{
                                            fontSize: "1em",
                                            fontWeight: 700,
                                            color: "#111827",
                                            }}
                                        >
                                            Delivery & Order Summary
                                        </div>

                                        <div
                                            style={{
                                                fontSize: "0.8em",
                                                color: "#6b7280",
                                            }}
                                        >
                                            Choose delivery preferences and review your order total.
                                        </div>

                                    </div>

                                    {/* Delivery Method */}
                                    <div className="mb-3">

                                    <label
                                        className="mb-1"
                                        style={{
                                            fontSize: "0.78em",
                                            fontWeight: 600,
                                            color: "#374151",
                                            display: "block",
                                        }}
                                    >
                                        Delivery Category
                                    </label>

                                    <select
                                        className="form-select font8 text-muted"
                                        value={delivery}
                                        onChange={handleDeliveryChange}
                                    >
                                        <option value="">
                                        Select delivery category
                                        </option>

                                        <option value="Instore Pickup">
                                        Instore Pickup
                                        </option>

                                        {DeliveryInfo?.map((item, index) => (
                                        <option
                                            key={index}
                                            value={`${item.location} - ${item.fee}`}
                                        >
                                            {item.location} • KES{" "}
                                            {new Intl.NumberFormat().format(
                                            item.fee
                                            )}
                                        </option>
                                        ))}
                                    </select>

                                    </div>

                                    {/* Address */}
                                    <div className="mb-3">

                                    <label
                                        className="mb-1"
                                        style={{
                                        fontSize: "0.78em",
                                        fontWeight: 600,
                                        color: "#374151",
                                        display: "block",
                                        }}
                                    >
                                        Delivery Address
                                    </label>

                                    {delivery === "Instore Pickup" ? (

                                        <input
                                            className="form-control font8"
                                            readOnly
                                            value="Instore Pickup"
                                        />

                                    ) : (

                                        <GooglePlacesInput
                                            value={location}
                                            onChange={(val) =>
                                                setLocation(val)
                                            }                                            
                                        />

                                    )}

                                    </div>

                                    {/* Voucher */}
                                    <label
                                        className="mb-1"
                                        style={{
                                        fontSize: "0.78em",
                                        fontWeight: 600,
                                        color: "#374151",
                                        display: "block",
                                        }}
                                    >
                                        <FaTags/> 
                                    </label>
                                    <div
                                        className="mb-4"
                                        style={{
                                            border: "1px solid #e5e7eb",
                                            borderRadius: "0.375rem",
                                            overflow: "hidden",
                                        }}
                                    >

                                        <div
                                            className="accordion voucher-accordion"
                                            id="voucherAccordion"
                                        >

                                            <div
                                            className="accordion-item border-0"
                                            >

                                            <div className="accordion-header">

                                                <button
                                                className="accordion-button collapsed shadow-none p-2"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#voucherCollapse"
                                                style={{
                                                    background: "#fff",
                                                    fontSize: "0.75em",
                                                    fontWeight: 600,
                                                    color: "#374151",
                                                }}
                                                >
                                                Have a promo code? 
                                                <div className="ms-auto">
                                                    <ChevronDown size={16} strokeWidth={2.5} />
                                                </div>
                                                </button>

                                            </div>

                                            <div
                                                id="voucherCollapse"
                                                className="accordion-collapse collapse"
                                            >

                                                <div className="accordion-body p-2 pt-0">

                                                <input
                                                    className="form-control font9"
                                                    placeholder="Enter voucher code"
                                                    value={voucher}
                                                    onChange={(e) =>
                                                        setVoucher(e.target.value)
                                                    }
                                                />

                                                <div
                                                    className="mt-2"
                                                    style={{
                                                    fontSize: "0.7em",
                                                    color: "#6b7280",
                                                    }}
                                                >
                                                    Discounts will be applied automatically at checkout.
                                                </div>

                                                </div>

                                            </div>

                                            </div>

                                        </div>

                                    </div>

                                    {/* Order Summary */}
                                    <div
                                    className="mb-4 p-3"
                                    style={{
                                        background: "#f8fafc",
                                        borderRadius: "14px",
                                        border: "1px solid #e5e7eb",
                                    }}
                                    >

                                    <div
                                        style={{
                                        fontSize: "1em",
                                        fontWeight: 600,
                                        color: "#111827",
                                        marginBottom: "12px",
                                        }}
                                    >
                                        Order Summary
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">

                                        <span
                                        style={{
                                            color: "#6b7280",
                                            fontSize: "0.8em",
                                        }}
                                        >
                                        Subtotal
                                        </span>

                                        <span
                                        style={{
                                            fontWeight: 600,
                                            color: "#111827",
                                        }}
                                        >
                                        {baseCurrency}{" "}
                                        {new Intl.NumberFormat().format(
                                            sum - deliveryFee
                                        )}
                                        </span>

                                    </div>

                                    {deliveryFee > 0 && (

                                        <div className="d-flex justify-content-between mb-2">

                                        <span
                                            style={{
                                            color: "#6b7280",
                                            fontSize: "0.8em",
                                            }}
                                        >
                                            Delivery
                                        </span>

                                        <span
                                            style={{
                                            fontWeight: 600,
                                            }}
                                        >
                                            {baseCurrency}{" "}
                                            {new Intl.NumberFormat().format(
                                            deliveryFee
                                            )}
                                        </span>

                                        </div>

                                    )}

                                    <hr
                                        style={{
                                        margin: "12px 0",
                                        opacity: 0.15,
                                        }}
                                    />

                                    <div className="d-flex justify-content-between">

                                        <span
                                        style={{
                                            fontWeight: 700,
                                            color: "#111827",
                                        }}
                                        >
                                        Total
                                        </span>

                                        <span
                                        style={{
                                            fontWeight: 700,
                                            fontSize: "1.1em",
                                            color: "#111827",
                                        }}
                                        >
                                        {baseCurrency}{" "}
                                        {new Intl.NumberFormat().format(sum)}
                                        </span>

                                    </div>

                                    </div>

                                    {/* Errors */}

                                    {error && (
                                    <div
                                        className="alert alert-danger py-2"
                                        style={{
                                        fontSize: "0.8em",
                                        }}
                                    >
                                        {error}
                                    </div>
                                    )}

                                    {VoucherError && (
                                    <div
                                        className="alert alert-warning py-2"
                                        style={{
                                        fontSize: "0.8em",
                                        }}
                                    >
                                        {VoucherError}
                                    </div>
                                    )}

                                    {/* CTA */}

                                    <button
                                    className="btn w-100 d-flex align-items-center justify-content-center gap-2"
                                    onClick={confirmOrderHandler}
                                    style={{
                                        background: "#111827",
                                        color: "#fff",
                                        borderRadius: "12px",
                                        padding: "14px",
                                        fontWeight: 600,
                                        fontSize: "0.9em",
                                        border: "none",
                                    }}
                                    >
                                    Complete Order
                                    <CreditCard size={16} />
                                    </button>

                                    <div
                                    className="text-center mt-3"
                                    style={{
                                        fontSize: "0.72em",
                                        color: "#6b7280",
                                    }}
                                    >
                                    </div>

                                </div>
                            </div>
                        </div>
                    )}  
                    {cartItems === 0 && (

                        vendor_login === "true" ? <>
                                <div className="row text-center"> 
                                    <h1 className="text-dark mt-3 fw800">Order is empty</h1> 
                                    <div className='row'><div className='col-12'><div className='ecartimg mt-2 mb-2'><img src={ecartimg}/></div> </div></div>                                       
                                    <Link to="/seller/pos">
                                        <button className="btn btn-info text-white">Back to POS <FaCashRegister /></button>
                                    </Link>
                                </div>
                        </> : <>
                                <div className="row text-center"> 
                                    <h1 className="text-dark mt-3 fw800">Your Shopping Cart<br/> is empty</h1> 
                                    <div className='row'><div className='col-12'><div className='ecartimg mt-2 mb-2'><img src={ecartimg}/></div> </div></div>                                       
                                    <Link to={homeroute}>
                                        <button className="btn btn-info text-white">Continue Shopping <ShoppingBag /></button>
                                    </Link>
                                </div>
                        </>
                        
                    )} 
                </>}
                {cartButtonClickStatus == false && <>
                    <div className="row">           
                        <div className="col-12 col-lg-4 reglogincon">
                            <button className='btn btn-dark-outline mb-2' onClick={backHandler}><ArrowLeft/> Back</button>
                            <div className="card shadow-sm border border-secondary border-opacity-10">
                                <div className="card-body">
                                    <div className="row ordbgrw pb-3">
                                        <div className="col-5 ord-sz1 pt-2"><font className="grey-text">Total</font><br/> 
                                            <span><b>{baseCurrency} {new Intl.NumberFormat().format(sum)}</b></span>
                                        </div>
                                        <div className="col-7 ord-sz1 pt-2"><font className="grey-text">Delivery Location:</font><br/> <b>{location}</b></div>
                                    </div> 
                                    {pymtFormData0.pay_mode == 0 &&
                                        <div>                                
                                            <p className='mb-2'>Kindly send payment to:</p>
                                            <div className='row'>
                                                {pymtFormData0.pay_mode_desc == "Bank" && <>
                                                    <div className='col-5 font9'>
                                                        <span className='grey-text'>Paybill</span>
                                                        <div className="input-group mb-1">
                                                            <input type="text" className="form-control border-0 p-0 h25" aria-describedby="button-addon2" value={paybill} readOnly/>
                                                        </div>
                                                    </div>
                                                    <div className='col-7 font9'>
                                                        <span className='grey-text'>Account Number</span>
                                                        <div className="input-group mb-1">
                                                            <input type="text" className="form-control border-0 p-0 h25" aria-describedby="button-addon2" value={input2} readOnly/>
                                                            <button className="btn btn-outline-secondary border-0 copybtn p-0 m-0" type="button" id="button-addon2" onClick={() => copyToClipboard(input2, 1)}>
                                                                
                                                                {!copySuccess && <p className='col-12 font9 m-0 p-0'><Copy width='20px'/></p>}
                                                                {copySuccess && <p className='col-12 text-success font9 m-0 p-0'><CheckCircle width='20px'/></p>}
                                                            </button>
                                                            <p className='col-12 text-success font9 m-0 p-0'></p>
                                                        </div>
                                                    </div>                                          
                                                </>}{pymtFormData0.pay_mode_desc == "Mpesa" && <>
                                                    <div className='col-12 font9'>
                                                        <span className='grey-text'>Mpesa Number</span>
                                                        <div className="input-group mb-1">
                                                            <input type="text" className="form-control border-0 p-0 h25" aria-describedby="button-addon2" value={input2} readOnly/>
                                                            <button className="btn btn-outline-secondary border-0 copybtn p-0 m-0" type="button" id="button-addon2" onClick={() => copyToClipboard(input2, 1)}>
                                                                
                                                                {!copySuccess && <p className='col-12 font9 m-0 p-0'><Copy width='20px'/></p>}
                                                                {copySuccess && <p className='col-12 text-success font9 m-0 p-0'><CheckCircle width='20px'/></p>}
                                                            </button>
                                                            <p className='col-12 text-success font9 m-0 p-0'></p>
                                                        </div>
                                                    </div>                                          
                                                </>}                                                                              
                                            </div>                                       
                                            
                                            <div className="mb-3 mt-3">
                                                    <label htmlFor="lnm" className="grey-text font9 mb-0 pb-0">Name</label>
                                                    <input type="text" className="form-control" id="lnm" name='username' onChange={inputHandler} value={ProfileData.username} />
                                                    {UsernameError && <p className='text-danger font8 p-0 m-0'>*Confirm Name</p>}
                                            </div>
                                            <div className="mb-3">
                                                    <label htmlFor="InputEmail" className="grey-text font9 mb-0 pb-0">Phone No.</label>
                                                    <input type="number" className="form-control" id="InputEmail" name='mobile' onChange={inputHandler} value={ProfileData.mobile} />
                                                    {MobileNoError && <p className='text-danger font8 p-0 m-0'>*Confirm Phone No Format 254 724 000 000</p>}
                                            </div>
                                            <div className="mb-3 mt-3">
                                                    <label htmlFor="lnm" className="grey-text font9 mb-0 pb-0">Email</label>
                                                    <input type="email" className="form-control" id="lnm" name='email' onChange={inputHandler} value={ProfileData.email} />                                                        
                                                    {EmailError && <p className="text-danger font8 p-0 m-0">Invalid email format. Kindly enter a valid email.</p>}
                                            </div>
                                            <>
                                                {clicked !== "POD" && (
                                                    <div className='ord_outrbx_div mt-4'>
                                                        {loadingPay && clicked === "PAV" ? (
                                                            <button className='ordprss11 br50r' disabled>Loading Whatsapp....</button>
                                                        ) : (
                                                            <button className='ordprss11 br50r' onClick={() => startUpload("PAV")}>
                                                                I have Paid
                                                            </button>
                                                        )}
                                                    </div>
                                                )}

                                                {clicked !== "PAV" && (
                                                    <div className='ord_outrbx_div mt-3 mb-2'>
                                                        {loadingPay && clicked === "POD" ? (
                                                            <button className='ordprss111' style={{ background: '#fff', color: '#333' }}><u>Loading Whatsapp....</u></button>
                                                        ) : (
                                                            <button className='ordprss111' style={{ background: '#fff', color: '#333' }} onClick={() => startUpload("POD")}>
                                                                <u>I will Pay on Delivery</u>
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        </div>
                                    }
                                    {pymtFormData0.pay_mode == 1 && <>
                                        <div className="tab-content pt-2 pymt pb-4" id="myTabContent">
                                            <div className="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">
                                                <>
                                                    <div className="mb-3 mt-3">
                                                            <label htmlFor="lnm" className="grey-text font9 mb-0 pb-0">Name</label>
                                                            <input type="text" className="form-control" id="lnm" name='username' onBlur={(e) => validateUsername(e.target.value)} onChange={inputHandler} value={ProfileData.username} />                                                        
                                                            {UsernameError && <small className="text-danger font8">Confirm Name</small>}
                                                    </div>
                                                    <div className="mb-3 mt-3">
                                                            <label htmlFor="lnm" className="grey-text font9 mb-0 pb-0">Email</label>
                                                            <input type="email" className="form-control" id="lnm" name='email' onBlur={(e) => validateEmail(e.target.value)}  onChange={inputHandler} value={ProfileData.email} />                                                        
                                                            {EmailError && <small className="text-danger font8">Invalid email format. Kindly enter a valid email.</small>}
                                                    </div>
                                                    {PayError && <p className='text-danger font9 text-center p-0 m-0'>{PayError}</p>}
                                                    {status == "Complete" && <p className='text-success font9 text-center p-0 m-0'>{status}, rerouting...</p>}      
                                                    { UsernameError0 == '1' && EmailError0 == '1' ? <>
                                                        {paymentMode === 'intasend' ? (
                                                            
                                                            <div>
                                                                <button onClick={handlePayNowClick} disabled={loadingPay} className="intaSendPayButton btn col-12 text-light bg-dark mt-4" data-amount={sum} data-first-name={ProfileData.username} data-email={ProfileData.email} data-currency="KES">      
                                                                    {loadingPay ? "Loading..." : "Pay Now"}
                                                                </button>
                                                            </div>

        
                                                            ) : (
                                                            <PaystackButton 
                                                                className='btn col-12 text-light bg-dark mt-4'
                                                                text="Complete"
                                                                currency="KES"
                                                                publicKey={publicKey}
                                                                email={ProfileData.email}
                                                                amount={sum * 100}
                                                                reference={orderId}
                                                                onSuccess={onSuccess}
                                                                onClose={onClose}
                                                            />
                                                        )}
                                                        
                                                    </> : <>                                                        
                                                        <button className='btn col-12 text-light bg-dark mt-3' disabled>Complete</button>
                                                    </>} 
                                                    
                                                </> 
                                            </div>
                                        </div>
                                        </>
                                    }
                                </div>  
                            </div>
                        </div>
                    </div>
                </>}
                <a
                    href={waLink}
                    ref={waAnchorRef}
                    style={{ display: 'none' }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                WhatsApp
                </a>


                 <CheckoutProgressModal totalOrders={7} />

            </section>    
        </>    
    );
}

export default Checkout;